import Request from '../utils/request'

export function getUploadTokenApi () {
  return Request({
    url: '/follow/aliyun/oss/token',
    method: 'get'
  })
}

